document.addEventListener('DOMContentLoaded', () => {
    
    const masthead = document.getElementById('masthead');
    const logo = document.querySelector('.header--logo');
    // Grab the main wrapper so we can adjust it when the logo becomes absolute
    const mainWrapper = document.querySelector('.header--main--wrapper');
    
    if (!masthead) return;

    let lastScrollY = window.scrollY;
    
    window.addEventListener('scroll', () => {
        const currentScrollY = window.scrollY;
        
        // 1. BREADCRUMBS & TITLE LOGIC
        if (currentScrollY > 220) {
            masthead.classList.add('hide-breadcrumbs');
        } else {
            masthead.classList.remove('hide-breadcrumbs');
        }

        // 2. SMART NAV LOGIC & LOGO LOGIC
        if (currentScrollY > 400) {
            
            // Hide/show nav based on scroll direction
            if (currentScrollY > lastScrollY) {
                masthead.classList.add('hide-nav');
            } else {
                masthead.classList.remove('hide-nav');
            }
            
            // Add 'is-scrolled' to the logo
            if (logo) {
                logo.classList.add('is-scrolled');
            }
            
            // Add a class to the wrapper to handle the missing logo space
            if (mainWrapper) {
                mainWrapper.classList.add('logo-is-scrolled'); 
            }
            
        } else {
            masthead.classList.remove('hide-nav');
            
            // Remove 'is-scrolled' from the logo
            if (logo) {
                logo.classList.remove('is-scrolled');
            }
            
            // Remove the spacer class from the wrapper
            if (mainWrapper) {
                mainWrapper.classList.remove('logo-is-scrolled');
            }
        }
        
        lastScrollY = currentScrollY;
    }, { passive: true });
});